import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/shared/models/state';
import { ApiService } from 'src/app/shared/services/api.service';
import { ContextService } from 'src/app/shared/services/ctx.service';
import { ApiHelperService } from 'src/app/shared/services/helpers/api-helper.service';
import { NavService } from 'src/app/shared/services/nav.service';
import { StateService } from 'src/app/shared/services/state.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-identify-user-modal',
  templateUrl: './identify-user-modal.component.html',
  styleUrls: ['./identify-user-modal.component.scss']
})
export class IdentifyUserModalComponent implements OnInit, OnDestroy {
  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

  state: Partial<AppState>;
  subs: Subscription;
  infoData: { icon: string; title: string, text: string; }[];

  constructor(
    public ctx: ContextService,
    private stateService: StateService,
    private dialog: MatDialog,
    private nav: NavService,
    private urlService: UrlService,
    private uitls: UtilsService,
  ) {
    this.subs = new Subscription();
    this.state = this.stateService.getStateValue();
    this.infoData = [
      {
        icon: 'user-icon',
        title: 'Más de 50.000 profesionales sanitarios',
        text: 'Tenemos a los mejores especialistas a tu servicio. Encuentra el que está más cerca de ti.'
      },
      {
        icon: 'calendar-icon',
        title: 'Pide cita cómodamente',
        text: 'Si eres cliente de MAPFRE podrás pedir cita con tu especialista desde tu móvil. Más cómodo, imposible.'
      },
      {
        icon: 'stethoscope',
        title: 'Servicios adicionales de calidad',
        text: ' Ofrecemos las mejores condiciones para estudios genéticos, medicina preventiva, estética. '
      },
    ];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.subs.add(
      this.stateService.getState().subscribe(state => { this.state = state; })
    );
  }

  slideNext() {
    this.swiper.swiperRef.slideNext(100);
  }

  slidePrev() {
    this.swiper.swiperRef.slidePrev(100);
  }

  async identifyCustomer(userIdentified: boolean) {
    if (userIdentified) {
      const url = this.urlService.getIdentifyUserUrls();
      this.uitls.openExternalUrl(url, false);
      return;
    }

    this.dialog.closeAll();
    this.nav.navTo('services');
  }
}
